import { Box, Button, CircularProgress, Divider, Stack } from '@mui/material'
import { FC, Fragment, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { CommentListSortTypeAtom } from '~/features/video_detail/atoms/CommentListSortTypeAtom'
import { useCommentsMutation } from '~/features/video_detail/hooks/comments/useCommentsMutation'
import { useCommentsQuery } from '~/features/video_detail/hooks/comments/useCommentsQuery'
import { CommentInputForm } from './comment/CommentInputForm'
import CommentRow from './comment/CommentRow'
import { CommentSortButton } from './comment/CommentSortButton'

const VideoDetailCommentTab: FC<{ id: string }> = ({ id }) => {
  const { data, loading, error, loadMore, hasNextPage } = useCommentsQuery(id)
  const { createComment } = useCommentsMutation(id)
  const commentListSortType = useRecoilValue(CommentListSortTypeAtom)

  const sortedComments = useMemo(() => {
    if (!data?.videoComments.edges) return []

    switch (commentListSortType) {
      case 'desc_like':
        return [...data?.videoComments.edges].sort((a, b) => b.node?.likeNum! - a.node?.likeNum!)
      case 'asc_comment_created':
        return [...data?.videoComments.edges].sort(
          (a, b) => new Date(b.node?.createdAt).getTime() - new Date(a.node?.createdAt).getTime(),
        )
      default:
        return data?.videoComments.edges
    }
  }, [commentListSortType, data])

  if (error) {
    console.error(error)
  }

  return (
    <Box paddingX={2}>
      <Box paddingY={2}>
        <CommentInputForm placeholder='post_review' onSubmitComment={createComment} />
      </Box>
      <CommentSortButton />
      {sortedComments.map((edge, idx) => (
        <Fragment key={idx}>
          {idx == 0 && <Divider />}
          <Box marginTop={2}>
            <CommentRow comment={edge.node!} />
          </Box>
          <Divider />
        </Fragment>
      ))}
      <Stack>
        {hasNextPage == true && (
          <Button onClick={loadMore}>
            <Trans i18nKey='view_more' />
          </Button>
        )}
        {loading && <CircularProgress />}
        {error && <></>}
      </Stack>
    </Box>
  )
}

export default VideoDetailCommentTab
